// extracted by mini-css-extract-plugin
export default {"item":"_68ed0cb5","isLegalLink":"_bebb0bf9","contact1stdibsLink":"_64adfb8a","contact1StdibsLink":"_64adfb8a"};